import type { CommentData } from '@liveblocks/client'

import type { EventProperties } from '@/lib/analytics/events'
import { cn } from '@/lib/ui/style-helpers'

import { CommentItem } from './comment-item'

type CommentThreadProps = {
  comments: CommentData[]
  readOnly?: boolean
  highlightedCommentId?: string | null
  trackingProps?: EventProperties
  // Callers rendering a collapsed thread pass the full reply count, which `comments` no longer shows.
  hadReplies?: boolean
  className?: string
}

export const CommentThread = ({
  comments,
  readOnly,
  highlightedCommentId,
  trackingProps,
  hadReplies,
  className,
}: CommentThreadProps) => {
  return (
    <div className={cn('flex flex-col gap-4', className)}>
      {comments.map((comment, index) => (
        <CommentItem
          key={comment.id}
          comment={comment}
          readOnly={readOnly}
          highlighted={comment.id === highlightedCommentId}
          isReply={index > 0}
          hadReplies={index === 0 && (hadReplies ?? comments.length > 1)}
          trackingProps={trackingProps}
        />
      ))}
    </div>
  )
}
